import './styles.scss';

const CtaSection = ({ section }) => {
    const { header, body, ctaUrl, ctaText } = section;

    return (
        <div className="cta-section">
            <div className="cta-content">
                {header && <h2>{header}</h2>}
                {body && <div className="cta-body" dangerouslySetInnerHTML={{ __html: body }} />}
                {ctaUrl && ctaText && (
                    <a
                        href={ctaUrl}
                        className="cta gold-fill"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {ctaText}
                    </a>
                )}
            </div>
        </div>
    );
};

export default CtaSection;
